import { API_URL, getApi, putApi, deleteApi, postApi } from "@/service/api";
import router from "../../router";

const routes = {
  api_status_mail_tracking: "/api/v01/tracking/StatusMailView/",
  api_factura_send_mail: "/api/v01/tracking/SendMailFacturaApiView/",
  api_factura: "/api/v01/tracking/listfacturasfile/",
  api_tracking: "/api/v01/tracking/",
  api_pobox: "/api/pobox/",
};

const state = {
  tracking: [],
  facturaPobox: [],
  statusMail: [],
  po_box: [],
};

const mutations = {
  // Pobox
  setPobox(state, payload) {
    state.po_box = payload;
  },
  // Facturas
  setFacturaPoBox(state, payload) {
    state.facturaPobox = payload;
  },
  // Mail
  setStatusMail(state, payload) {
    state.statusMail = payload;
  },
  // Tracking
  setTracking(state, payload) {
    state.tracking = payload;
  },
};

const actions = {
  async submitFile(formData) {


    const res = {
      success: false,
    };

    try {
      const response = await postApi(
        API_URL + "/api/v01/tracking/uploads/",
        formData
      );
      console.log("SUCCESS!!", response.statusText);
      res.success = true;
      res.status = 201;
    } catch (error) {
      console.log("FAILURE!!", error.response.data);
      res.success = false;
      res.response = error.response;
      this.textErrorUploadFile = error.response.data;
    }

    if (res.success && res.status === 201) {
      this.filesFactura = "";
      this.textLabelUploadFactura = "Seleccione su Factura";
      this.initialize();
      this.closeModal();
    }
  },

  // Pobox
  listPoBox({ commit }) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      commit("auth/LOGIN_REQUEST", null, { root: true });
      const response = getApi(API_URL + routes.api_pobox);
      response.then((res) => {
        commit("setPobox", res.data);
        commit("auth/LOGIN_SUCCESS", null, { root: true });
      });
      response.catch(() => {
        localStorage.removeItem("token");
        commit("auth/LOGIN_ERROR", null, { root: true });
        router.push("/login");
      });
    }
  },
  // Status Mail
  getStatusMail({ commit }, tracking) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      commit("auth/LOGIN_REQUEST", null, { root: true });
      const pobox = tracking.po_box;
      const idens = tracking.idens;

      const url =
        API_URL + routes.api_status_mail_tracking + `${pobox}/${idens}`;

      getApi(url)
        .then((res) => {
          commit("setStatusMail", res.data);
          commit("auth/LOGIN_SUCCESS", null, { root: true });
        })

        .catch((error) => {
          console.log(error);
          // localStorage.removeItem("token");
          // commit("auth/LOGIN_ERROR", null, {root: true});
          // router.push('/login');
        });
    }
  },
  // Facturas
  listFacturaPoBox({ commit }, tracking) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      commit("auth/LOGIN_REQUEST", null, { root: true });
      const pobox = tracking.po_box;
      const idens = tracking.idens;
      const response = getApi(
        API_URL + routes.api_factura + `${pobox}/${idens}`
      );
      response.then((res) => {
        commit("setFacturaPoBox", res.data);
        commit("auth/LOGIN_SUCCESS", null, { root: true });
      });

      response.catch(() => {
        localStorage.removeItem("token");
        commit("auth/LOGIN_ERROR", null, { root: true });
        router.push("/login");
      });
    }
  },
  sendMailFacturaPoBox({ commit }, tracking) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      commit("auth/LOGIN_REQUEST", null, { root: true });
      const pobox = tracking.po_box;
      const idens = tracking.idens;

      const data = {
        url: API_URL + routes.api_factura_send_mail + `${pobox}/${idens}`,
        data: {},
      };
      // let response

      const response = postApi(data)
        .then((res) => {
          commit("auth/LOGIN_SUCCESS", null, { root: true });
          return res.data;
        })

        .catch((error) => {
          console.log(error);
          // localStorage.removeItem("token");
          // commit("auth/LOGIN_ERROR", null, {root: true});
          // router.push('/login');
        });
      return response;
    }
  },

  // Tracking
  listTracking({ commit }) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      commit("auth/LOGIN_REQUEST", null, { root: true });
      const response = getApi(API_URL + routes.api_tracking);
      response.then((res) => {
        const newArray = res.data.map((element) =>
          Object.assign(element, {
            peso_with_unidad: `${element.peso} ${element.unidad_peso}`,
          })
        );
        commit("setTracking", newArray);
        commit("auth/LOGIN_SUCCESS", null, { root: true });
      });

      response.catch(() => {
        localStorage.removeItem("token");
        commit("auth/LOGIN_ERROR", null, { root: true });
        router.push("/login");
      });
    }
  },

  putTracking({ commit }, data) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      const url = API_URL + routes.api_tracking + data.id + "/";

      data = {
        url: url,
        data: data,
      };

      const response = putApi(data);
      response
        .then(() => {
          // console.log("Response", res.data);
          commit("auth/LOGIN_SUCCESS", null, { root: true });
        })

        .catch((error) => {
          localStorage.removeItem("token");
          console.log("Error:", error);
          // commit("auth/LOGIN_ERROR", null, {root: true});
          router.push("/login");
        });
    }
  },

  deleteTracking({ commit }, data) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      const url = API_URL + routes.api_tracking + data.id + "/";
      const response = deleteApi({ url: url });

      response.catch(() => {
        localStorage.removeItem("token");
        commit("auth/LOGIN_ERROR", null, { root: true });
        router.push("/login");
      });
    }
  },

  postTracking({ commit }, data) {
    if (!localStorage.getItem("token")) {
      router.push("/login");
    } else {
      const url = API_URL + routes.api_tracking;
      data = {
        url: url,
        data: data,
      };

      const response = postApi(data);

      response
        .then(() => {
          // console.log("Response", res.data);
          commit("auth/LOGIN_SUCCESS", null, { root: true });
        })

        .catch(function(error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(
              "TODO, poner este error en un alert -> error.data",
              error.response.data
            );
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log("error.request", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          // console.log('error.config', error.config);
        });

      // response.catch((error) => {
      //     console.error(error);

      //     // commit("auth/LOGIN_ERROR", null, {root: true});
      //     // localStorage.removeItem("token");
      //     // router.push('/login');
      //   });
    }
  },
};

const getters = {};

// exportar propiedades
export const tracking = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
